<template>
  <footer id="footer" v-bind:class="{ 'kobler': kobler }">
    <div class="footer_top" v-if="!kobler">
      <div class="container-fluid">
        <div class="row">
          <div class="position-footer-top">
            <section id="base_newsletter">
              <div class="newsletter-content">
                <div class="title-wrapper">
                  <h5>Đăng ký email để nhận thông tin cập nhật về sản phẩm.</h5>
                </div>
              </div>

              <div class="newsletter-wrapper">
                <form class="newsletter-form" name="newsletter-form">
                  <input class="text-email" id="subscribe_email" name="subscribe_email" placeholder="Your email address"
                    type="email" value="">
                  <button class="btn btn-lg btn-submit btn-primary subscribe-btn"><span class="btn-text">Đăng
                      ký</span></button>
                </form>

                <div id="notification-normal">&nbsp;</div>
              </div>
            </section>


          </div>
          <div class="position-footer-top">


          </div>

        </div>
      </div>
    </div>
    <div class="container-fluid pt-4">
      <div class="row">
        <div class="col-sm-6 column middle-content d-flex">
          <div class="position-footer-middle">
            <div class="footer_aboutus_cms">
              <img style="margin-bottom: 10px; height: 55px; margin-right: 5px;" src="/images/logo-kobler.png"
                v-if="kobler">
              <img style="margin-bottom: 10px; height: 55px;" src="/images/logo.svg" v-if="!kobler">
              <p class="pt-2" v-if="kobler">
                Alphatech - nhà phân phối các sản phẩm Kobler chính hãng.
              </p>
              <button v-if="edit == 'true'" class="btn btn-sm btn-success" @click="addAddress">+</button>
              <p v-for="(a, i) in data.address" :key="i" class="pt-2">
                <span v-if="edit != 'true'">{{ a.address }}</span>
                <input v-if="edit == 'true'" type="text" class="form-control" v-model="a.address" />
                <button v-if="edit == 'true'" class="btn btn-sm btn-danger" @click="removeAddress(a)">-</button>
              </p>
              <ul class="footer-social list-unstyled d-flex">
                <li class="mt-0"><a href="#"><img src="/image/catalog/demo/theme/facebook-social.svg"></a>
                </li>
                <li class="mt-0"><a href="#"><img src="/image/catalog/demo/theme/instagram-social.svg"></a>
                </li>
                <li class="mt-0"><a href="#"><img src="/image/catalog/demo/theme/linkedin-social.svg"></a>
                </li>
                <li class="mt-0"><a href="#"><img src="/image/catalog/demo/theme/watsapp-social.svg"></a>
                </li>
              </ul>
            </div>


          </div>
          <div class="position-footer-middle">
            <div class="footer_contact">
              <h5><span>Bạn cần giúp đỡ?</span><button v-if="edit == 'true'" v-on:click="addContact"
                  class="btn btn-sm btn-success">+</button></h5>

              <div class="footer-toggle">
                <div v-for="c in data.contact" :key="c">
                  <div v-if="edit == 'true'" class="footer-contact-item-edit-wrap">
                    <div class="footer-contact-item-edit">
                      <div class="type">
                        <select class="form-select" v-model="c.type">
                          <option value="tel">Điện thoại</option>
                          <option value="text">Văn bản</option>
                          <option value="mailto">Email</option>
                          <option value="line">Line</option>
                        </select>
                      </div>
                      <div class="icon">
                        <select class="form-select" v-model="c.icon">
                          <option value="fa-phone-alt">
                            &#xf879;
                          </option>
                          <option value="fa-alarm-clock">
                            &#xf34e;
                          </option>
                          <option value="fa-envelope">
                            &#xf0e0;
                          </option>
                        </select>
                      </div>
                      <div class="remove">
                        <button class="btn btn-sm btn-danger" @click="removeContact(c)">-</button>
                      </div>
                      <div class="text">
                        <input type="text" class="form-control" v-model="c.value" />
                      </div>
                    </div>
                  </div>
                  <hr v-if="edit != 'true' && c.type == 'line'" />
                  <div class="footer-contact-item" v-if="edit != 'true' && c.type == 'tel'">
                    <div class="icon">
                      <i :class="'fas ' + c.icon"></i>
                    </div>
                    <div class="link">
                      <a :href="'tel:' + c.value.replaceAll(' ', '').replaceAll('.', '')">{{ c.value }}</a>
                    </div>
                  </div>
                  <div class="footer-contact-item" v-if="edit != 'true' && c.type == 'text'">
                    <div class="icon">
                      <i :class="'fas ' + c.icon"></i>
                    </div>
                    <div class="text">
                      {{ c.value }}
                    </div>
                  </div>
                  <div class="footer-contact-item" v-if="edit != 'true' && c.type == 'mailto'">
                    <div class="icon">
                      <i :class="'fas ' + c.icon"></i>
                    </div>
                    <div class="link">
                      <a :href="'mailto:' + c.value">{{ c.value }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="col-sm-6 column">
          <h5><span>Danh mục sản phẩm</span></h5>
          <ul class="cate-list list-unstyled footer-toggle" v-if="!kobler">
            <li v-for="lv1 in navMenu" :key="lv1._id">
              <router-link :to="cateLink(lv1)">
                {{ lv1.name }}
              </router-link>
            </li>
          </ul>

          <ul class="cate-list list-unstyled footer-toggle" v-if="kobler">
            <li>
              <router-link to="/danh-muc/san/6806434f75061b4155517444">
                Sàn thạch anh Kobler
              </router-link>
            </li>
            <li>
              <router-link to="/danh-muc/phu-kien/6806437975061b4155517445">
                Phụ kiện sàn Kobler
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
//eslint-disable vue/valid-v-model

export default {
  props: ["edit", "data", "kobler"],
  computed: {
    navMenu() {
      return this.$store.getters.navData;
    }
  },
  mounted() {
    console.log(this.data);
  },
  methods: {
    addAddress() {
      // eslint-disable-next-line vue/no-mutating-props
      this.data.address.push({ address: "" });
    },
    removeAddress(a) {
      // eslint-disable-next-line vue/no-mutating-props
      this.data.address.splice(this.data.address.indexOf(a), 1);
    },
    addContact() {
      // eslint-disable-next-line no-undef, vue/no-mutating-props
      this.data.contact.push({ type: "tel", icon: "fa-phone-alt", value: "" });
    },
    removeContact(c) {
      // eslint-disable-next-line vue/no-mutating-props
      this.data.contact.splice(this.data.contact.indexOf(c), 1);
    },
    cateLink(cateObj) {
      return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
    },
    resizeImage(link, width, height) {
      const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
      if (test) {
        // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
        return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
      } else {
        return link;
      }
    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
  },
};
</script>
<style lang="less">
footer {
  &.kobler {
    padding-top: 20px;
    border-top: 1px solid #ccc;
  }

  color: #777777;

  .footer_aboutus_cms {
    padding-left: 20px;
  }
}

#footer {
  margin-top: 60px;
  text-align: left;

  ul.cate-list.list-unstyled {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 0;

    li {
      width: 300px;

      a {

        text-transform: capitalize;
      }
    }
  }

  .footer-contact-item-edit-wrap {
    margin-bottom: 20px;

    .footer-contact-item-edit {
      display: flex;
      width: 100%;
      flex-wrap: wrap;

      select,
      option {
        font-family: "Font Awesome 6 Pro";
        font-weight: 900;
      }

      .icon {
        width: 70px;
      }

      .type {
        flex: 1;
      }

      .text {
        width: 100%;
      }
    }

  }

  .footer_top {
    background-color: #11a859;
    padding: 35px 0;

    .newsletter-content {
      .title-wrapper {
        h5 {
          text-align: center;
          color: white;
        }
      }

    }

    .newsletter-wrapper {
      .newsletter-form {
        display: flex;
        justify-content: center;

        input,
        button {
          height: 36px;
          line-height: 21px;
        }

        input {
          border-top-left-radius: 18px;
          border-bottom-left-radius: 18px;
          border: none;
          padding-left: 18px;
          width: 350px;
          max-width: calc(90% - 80px);
          outline: none;

          &:focus {
            outline: none;
          }
        }

        button {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-top-right-radius: 18px;
          border-bottom-right-radius: 18px;
          background-color: black;
          font-size: 16px;

          border: none;

        }
      }
    }
  }

  .position-footer-middle {
    width: 100%;
  }

  .footer-social {
    li {
      min-width: 40px;
    }
  }

  .middle-content {
    flex-wrap: wrap;
  }

  a {
    color: inherit;
    text-decoration: none;

  }
}

#footer p {
  color: var(--global-palette3);
  line-height: 28px;
}

#footer hr {
  border-bottom: 1px solid var(--border-color);
}

#footer .footer_top {
  padding: 35px 0;
  width: 100%;
}

#footer .footer_middle {
  padding-top: 65px;
  padding-bottom: 65px;
  background-color: var(--global-palette9);
  float: left;
  width: 100%;
}

footer h5 {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  font-family: var(--global-heading-font-family);
  letter-spacing: 0;
  margin-top: 0;
  margin-bottom: 24px;
  color: #11a859;
  margin-bottom: 20px;
}

footer.kobler h5 {
  color: black;
  position: relative;
  display: inline-block;
  padding-bottom: 6px;

  &::after {
    position: absolute;
    content: "";
    height: 2px;
    bottom: 0;
    left: 33%;
    width: 33%;
    background-color: #ed1c24;
  }

  &::before {
    position: absolute;
    content: "";
    height: 2px;
    bottom: 0;
    left: 66%;
    width: 33%;
    background-color: #fcc90c;
  }

  span {
    display: inline-block;

    &::after {
      position: absolute;
      content: "";
      height: 2px;
      bottom: 0;
      left: 0;
      width: 33%;
      background-color: black;

    }
  }

}

#footer .footer_middle li+li {
  margin-top: 12px;
}

#footer .footer_middle a:not(.mobile_togglemenu) {
  font-size: 14px;
  letter-spacing: 0;
}

#footer .footer_middle a:not(.mobile_togglemenu):hover {
  text-decoration: underline;
}

#footer .footer_middle .middle-content {
  -ms-grid-columns: 0.7fr 10px 1fr;
  grid-template-columns: 0.7fr 1fr;
  gap: 10px;
}

#footer .footer_middle .middle-content .footer_aboutus_cms img {
  margin-bottom: 16px;
}

#footer .footer_middle .middle-content .footer_aboutus_cms .footer-social {
  margin-top: 24px;
}

#footer .footer_middle .middle-content .footer_aboutus_cms .footer-social li+li {
  padding-left: 24px;
}

#footer .footer_middle .middle-content .footer_aboutus_cms .footer-social li img {
  margin-bottom: 0;
}

#footer {

  .footer-contact-item {
    display: flex;

    .icon {
      width: 30px;
    }

  }
}

#footer .footer_middle .middle-content .footer_contact {
  position: relative;
  padding: 0 70px;
}

#footer .footer_middle .middle-content .footer_contact::after {
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 100%;
  background: var(--border-color);
  margin: auto;
}

#footer .footer_middle .middle-content .footer_contact .contact {
  margin-bottom: 20px;
}

#footer .footer_middle .middle-content .footer_contact .contact .contact-phone-text {
  font-size: 18px;
  font-weight: 500;
}

#footer .footer_middle .middle-content .footer_contact .contact-email-text a {
  font-size: 16px;
  font-weight: 500;
}

#footer .footer_bottom {
  background: var(--global-palette7);
  padding: 20px 0;
  float: left;
  width: 100%;
}

#footer .footer_bottom .bottom-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}


@media (min-width: 992px) {
  #footer {
    margin-top: 60px;
    text-align: left;

    .position-footer-middle {
      flex: 1;
    }

  }
}
</style>